import { Button, InputNumber, Modal } from 'antd';

import './chargeModel.scss';

interface ConfirmModalProps {
	open: boolean;
	onDiscard: any;
	onConfirm: any;
	isLoading: boolean;
}

function ChargeModalComponent({ open, isLoading, onDiscard, onConfirm }: ConfirmModalProps) {
	return (
		<>
			<Modal
				open={open}
				title="Charge Wallet"
				className="chargeModal"
				onCancel={onDiscard}
				footer={[
					<Button key="discard" className="discard" onClick={onDiscard}>
						Discard
					</Button>,
					<Button key="confirm" type="primary" onClick={onConfirm} loading={isLoading}>
						Charge now
					</Button>,
				]}>
				<h6>Charge your account</h6>

				<p>Add money to your account</p>

				<InputNumber size="large" addonAfter={<span style={{ paddingInline: 20, color: '#333', fontSize: 14 }}>SAR</span>} defaultValue={0} />
			</Modal>
		</>
	);
}

export default ChargeModalComponent;
